import Head from "next/head";
import { wrapper } from "@/redux/Store";

import CommunityFaqPage from "@/containers/StaticPages/Community/faqs";
import { renderMetaData } from "@/utils";
const CommunityFaq = () => {
  const metaData = {
    title: "Communities FAQs",
    description: "Communities FAQs",
    h1Text: "Communities FAQs",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <CommunityFaqPage />
      </main>
    </>
  );
};

export default CommunityFaq;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
